import { EmptyState } from '@components/EmptyState';
import { IconArrowForward, SearchListIcon, SelectFromListIcon, EmptyStateIcon, DatabaseCheckIcon } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const EmptyStatesSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Empty States"
      description="Placeholder content when no data is available."
      figmaNodeId="134-710"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>With Primary Action</h3>
      <div className={styles.emptyStateBox}>
        <EmptyState
          icon={<SearchListIcon width={82} height={62} />}
          title="No types added yet"
          subtitle="Start by adding your first type to generate and manage your leads"
          primaryActionText="Add New Type"
          onPrimaryAction={() => alert('Add clicked!')}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>No Action</h3>
      <div className={styles.emptyStateBox}>
        <EmptyState
          icon={<SelectFromListIcon width={82} height={62} />}
          title="No Type Selected"
          subtitle="Select a type from the list to view details"
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>With Secondary Action</h3>
      <div className={styles.emptyStateBox}>
        <EmptyState
          icon={<EmptyStateIcon width={82} height={62} />}
          title="No Results Found"
          subtitle="Try adjusting your search or filters"
          primaryActionText="Clear Filters"
          onPrimaryAction={() => alert('Clear clicked!')}
          showSecondaryAction
          secondaryActionText="Learn More"
          onSecondaryAction={() => alert('Secondary clicked!')}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Type Already Setup (node-id=33-273)</h3>
      <div className={styles.emptyStateBox}>
        <EmptyState
          icon={<DatabaseCheckIcon width={82} height={82} />}
          subtitle="Good News - this business type has already been setup"
          primaryActionText="Manage Business Type"
          hidePrimaryActionLeadingIcon
          primaryActionTrailingIcon={<IconArrowForward size={18} />}
          onPrimaryAction={() => alert('Manage clicked!')}
          showSecondaryAction
          secondaryActionText="Search for a different type"
          onSecondaryAction={() => alert('Search clicked!')}
        />
      </div>
      <p className={styles.hint}>
        This variant has no title, uses a trailing icon on the primary button, and a text-only secondary
        action.
      </p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Minimal Size (node-id=379-4152)</h3>
      <div className={styles.emptyStateBox}>
        <EmptyState
          size="minimal"
          icon={<SelectFromListIcon width={40} height={30} />}
          title="No types added yet"
          subtitle="Start by adding your first type to generate and manage your leads"
        />
      </div>
      <p className={styles.hint}>
        Compact variant with smaller icon (40px), smaller typography, and no action buttons. Use{' '}
        <code>{`size="minimal"`}</code>.
      </p>
    </div>
  </section>
);
